import { RepositoryBuilder } from 'alto-orm/lib/orm'

import Setting from './setting'

SettingsRepository = new RepositoryBuilder

SettingsRepository.registerRelation(Setting, '/settings/crud/settings')

export default SettingsRepository # takes backendUrl and auth
